var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0835 6.139C4.0835 5.72639 4.2474 5.33068 4.53916 5.03892C4.83092 4.74716 5.22664 4.58325 5.63925 4.58325H10.6944C10.8987 4.58325 11.101 4.62349 11.2898 4.70168C11.4785 4.77986 11.65 4.89446 11.7945 5.03892C11.939 5.18339 12.0536 5.35489 12.1317 5.54364C12.2099 5.73239 12.2502 5.9347 12.2502 6.139V11.1942C12.2502 11.3985 12.2099 11.6008 12.1317 11.7895C12.0536 11.9783 11.939 12.1498 11.7945 12.2943C11.65 12.4387 11.4785 12.5533 11.2898 12.6315C11.101 12.7097 10.8987 12.7499 10.6944 12.7499H5.63925C5.43494 12.7499 5.23264 12.7097 5.04389 12.6315C4.85513 12.5533 4.68363 12.4387 4.53916 12.2943C4.3947 12.1498 4.2801 11.9783 4.20192 11.7895C4.12374 11.6008 4.0835 11.3985 4.0835 11.1942V6.139Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34033 10.2632C2.16125 10.1615 2.0123 10.0142 1.90861 9.83619C1.80492 9.65822 1.7502 9.45597 1.75 9.25V3.41667C1.75 2.775 2.275 2.25 2.91667 2.25H8.75C9.1875 2.25 9.4255 2.47458 9.625 2.83333",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.6d5bbad6e9c1c839adb0394e0e40e646.svg";
export { ForwardRef as ReactComponent };